import store from 'shared/store'
import Storage from 'views/assets/scripts/services/storage/storage'
import { PRESCRIPTION_TYPE_NO_PRESCRIPTION } from 'shared/consts/productTemplates'
import { UPDATE_SELECT } from 'shared/store/ducks/events'

const CHOICES_INSTANCE_SELECTOR = '[name*="prescription_type"]'
const PRODUCT_VARIANT_LINK_SELECTOR =
  '[data-clientside-hook~="productVariant__link"]'

const storage = new Storage('sessionStorage')

export const handleVariantClick = prescriptionType => {
  if (!storage.isAvailable()) {
    return null
  }

  const variantLinks = [
    ...document.querySelectorAll(PRODUCT_VARIANT_LINK_SELECTOR)
  ]

  return variantLinks.map(variantLink => {
    const id = variantLink.dataset.productVariantId || null

    const onClick = () => {
      if (prescriptionType !== PRESCRIPTION_TYPE_NO_PRESCRIPTION) {
        storage.set(id, prescriptionType)
      }
    }

    variantLink.addEventListener('click', onClick)

    return variantLink
  })
}

export default () => {
  if (!storage.isAvailable()) {
    return null
  }

  const {
    ProductVariantsInitialState: { currentVariantId }
  } = store.getComponentInitialState()

  const prescriptionSelects = [
    ...document.querySelectorAll(CHOICES_INSTANCE_SELECTOR)
  ]

  if (prescriptionSelects.length > 0) {
    const prescriptionType = storage.get(currentVariantId)

    if (prescriptionType) {
      prescriptionSelects.forEach(select => {
        store.dispatch({ type: UPDATE_SELECT, select, value: prescriptionType })
      })

      storage.clear()
    }

    const handlePrescriptionTypeChange = event => {
      const {
        target,
        target: { value }
      } = event

      prescriptionSelects.forEach(select => {
        if (!select.isEqualNode(target)) {
          store.dispatch({ type: UPDATE_SELECT, select, value })
        }
      })
    }

    prescriptionSelects.forEach(select => {
      select.addEventListener('change', handlePrescriptionTypeChange)
    })

    return handleVariantClick(prescriptionSelects[0].value)
  }

  return null
}
